export const DOWNLOAD_DOC = 'equipment/contract/DOWNLOAD_DOC'
export const DOWNLOAD_DOC_DONE = 'equipment/contract/DOWNLOAD_DOC_DONE'
export const DOWNLOAD_DOC_FAIL = 'equipment/contract/DOWNLOAD_DOC_FAIL'

export const DELETE_DATA = 'equipment/contract/DELETE_DATA'
export const DELETE_DATA_DONE = 'equipment/contract/DELETE_DATA_DONE'
export const DELETE_DATA_FAIL = 'equipment/contract/DELETE_DATA_FAIL'

export const SET_XML = 'equipment/contract/SET_XML'
export const SET_XML_DONE = 'equipment/contract/SET_XML_DONE'
export const SET_XML_FAIL = 'equipment/contract/SET_XML_FAIL'

export const GET_SPO_LIST = 'equipment/contract/GET_SPO_LIST'
export const GET_SPO_LIST_DONE = 'equipment/contract/GET_SPO_LIST_DONE'
export const GET_SPO_LIST_FAIL = 'equipment/contract/GET_SPO_LIST_FAIL'
